import React, { Component } from "react";
import instance from "../../axios";
import Loader from "../../Layout/Loader";
import { getCompanyById } from "../../Helpers";
import {
  BayanatDeliveryNoteMui,
  mapDebitNoteToDoc,
  printMuiDoc,
} from "../../Components/Documents";

let serverTimeZoneName = "";

const resolveTimezoneFromQuery = (raw) => {
  try {
    return decodeURIComponent((raw || "").split("&")[0]) || "Asia/Riyadh";
  } catch (e) {
    return (raw || "").split("&")[0] || "Asia/Riyadh";
  }
};

class DebitNoteDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data1: {},
      loader: false,
      company: null,
      didAutoPrint: false,
    };
  }

  componentWillMount() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    const queryString = window.location.search;
    const res = queryString.split("?&token=");
    const parts = (res[1] || "").split("&timezone=");
    const noteId = parts[0];
    serverTimeZoneName = resolveTimezoneFromQuery(parts[1]);

    this.setState({ loader: true }, () => {
      Promise.all([
        instance({
          method: "GET",
          url: `/api/creditdebitnotes/${noteId}`,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }),
        instance({
          method: "GET",
          url: `/api/creditdebitnotes/${noteId}/items`,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }).catch(() => null),
      ])
        .then(([noteRes, itemsRes]) => {
          const note =
            noteRes && typeof noteRes === "object" && !Array.isArray(noteRes)
              ? noteRes
              : {};
          const items = Array.isArray(itemsRes)
            ? itemsRes
            : Array.isArray(itemsRes?.data)
              ? itemsRes.data
              : Array.isArray(note.items)
                ? note.items
                : [];
          const data1 = { ...note, items };

          let companyId = data1?.companyId || userInfo?.companyId;
          if (companyId) {
            getCompanyById(companyId)
              .then((company) => this.setState({ company }))
              .catch((error) => console.error(error.message));
          }
          this.setState({ data1, loader: false });
        })
        .catch((error) => {
          console.log("error ====", error);
          this.setState({ loader: false });
        });
    });
  }

  componentDidUpdate() {
    this.maybeAutoPrint();
  }

  replaceAmpersands(obj) {
    if (!obj || typeof obj !== "object") return;
    for (const prop in obj) {
      if (typeof obj[prop] === "string") {
        obj[prop] = obj[prop].replace(/amp;/g, "");
      } else if (typeof obj[prop] === "object" && obj[prop] !== null) {
        this.replaceAmpersands(obj[prop]);
      }
    }
  }

  buildDoc() {
    const { data1, company } = this.state;
    if (!data1 || !Object.keys(data1).length) return null;
    const data = data1;
    this.replaceAmpersands(data);
    return mapDebitNoteToDoc(data, company, {
      timezone: serverTimeZoneName,
    });
  }

  maybeAutoPrint() {
    const params = new URLSearchParams(window.location.search);
    const autoPrint = params.get("autoPrint");
    const { loader, data1, didAutoPrint } = this.state;
    if (
      loader ||
      !data1 ||
      !Object.keys(data1).length ||
      didAutoPrint ||
      !autoPrint
    ) {
      return;
    }
    this.setState({ didAutoPrint: true }, () => {
      const doc = this.buildDoc();
      printMuiDoc({ title: doc?.titleEn || "Tax Debit Note" }).then(() => {
        window.onafterprint = () => {
          try {
            window.close();
          } catch (e) {
            // ignore
          }
        };
      });
    });
  }

  render() {
    const { loader, data1 } = this.state;
    if (loader || !data1 || !Object.keys(data1).length) {
      return <Loader component="filter" />;
    }
    return <BayanatDeliveryNoteMui doc={this.buildDoc()} />;
  }
}

export default DebitNoteDetail;
